import { render, staticRenderFns } from "./ConsultCard.vue?vue&type=template&id=469e0869&scoped=true"
import script from "./ConsultCard.vue?vue&type=script&lang=js"
export * from "./ConsultCard.vue?vue&type=script&lang=js"
import style0 from "./ConsultCard.vue?vue&type=style&index=0&id=469e0869&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469e0869",
  null
  
)

export default component.exports